/**
 * The header's appearance control: one icon, one popover, every choice.
 * Theme (System / Light / Dark / Black), Skin (Studio / Paper / Console) and
 * the photograph treatment. No settings page needed to change the look.
 */
import { useState } from 'react'
import { IconMoon, IconSun, IconContrast } from '@tabler/icons-react'
import { IconButton, Popover, Segmented } from '../ui/kit'
import { SKINS, THEMES, useTheme, type PhotoMode, type ThemePreference } from './ThemeProvider'

export function AppearanceControl() {
  const { theme, resolved, skin, photo, setTheme, setSkin, setPhoto } = useTheme()
  const [open, setOpen] = useState(false)
  const Icon = resolved === 'light' ? IconSun : resolved === 'black' ? IconContrast : IconMoon
  return (
    <Popover open={open} onClose={() => setOpen(false)} anchor={
      <IconButton label="Appearance" expanded={open} onClick={() => setOpen(o => !o)}><Icon className="ic" aria-hidden="true" /></IconButton>
    }>
      <div className="pop-title">Appearance</div>
      <div className="pop-label">Theme</div>
      <Segmented<ThemePreference> wide label="Theme" value={theme} onChange={setTheme} options={THEMES.map(t => ({ value: t.id, label: t.label }))} />
      <div className="pop-label">Skin</div>
      <div className="skins">
        {SKINS.map(s => (
          <button type="button" key={s.id} className={['skin-opt', skin === s.id ? 'is-on' : ''].filter(Boolean).join(' ')} onClick={() => setSkin(s.id)} aria-pressed={skin === s.id}>
            <i style={{ '--sw': s.swatch, '--ac': s.accent } as React.CSSProperties} className="skin-swatch" />{s.label}
          </button>
        ))}
      </div>
      <div className="pop-label">Photographs</div>
      <Segmented<PhotoMode> wide label="Photographs" value={photo} onChange={setPhoto} options={[{ value: 'cover', label: 'Fill the box' }, { value: 'whole', label: 'Show whole' }]} />
      <div className="pop-note">Remembered on this device. Also in Settings → Appearance.</div>
    </Popover>
  )
}
